import React, {createContext, useContext, useEffect, useState} from 'react';

const UseActionContext = createContext();

export const useActionContext = () => useContext(UseActionContext);

export const ActionProvider = ({children}) => {
    const [actionDetails, setActionDetails] = useState({type: null, isSuccess: false, data: null})

    useEffect(() => {
        if(actionDetails.isSuccess) {
            setTimeout(() =>{
                setActionDetails({type: null, isSuccess: false, data: null})
            },1000)
        }
    }, [actionDetails]);

    return (
        <UseActionContext.Provider value={{actionDetails, setActionDetails}}>
            {children}
        </UseActionContext.Provider>
    )
}